export enum CuttingPackageStatus {
  PENDING = 'oczekuje',
  IN_PROGRESS = 'w trakcie',
  NOT_COMPLETE = 'nie kompletne',
  READY = 'gotowy',
}
